export const QR_REDIRECT_QUERY_KEYS = ['to', 'url', 'redirect'];

export function parseQrRedirectTarget(search) {
    const params = new URLSearchParams(search || '');
    for (const key of QR_REDIRECT_QUERY_KEYS) {
        const value = params.get(key);
        if (value && value.trim()) {
            return value.trim();
        }
    }
    return null;
}

export function isSafeRedirectTarget(target) {
    if (!target || typeof target !== 'string') {
        return false;
    }

    const trimmed = target.trim();
    if (!trimmed) {
        return false;
    }

    if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
        return true;
    }

    try {
        const parsed = new URL(trimmed);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch (_) {
        return false;
    }
}

export function isExternalRedirectTarget(target) {
    return /^https?:\/\//i.test(target.trim());
}

export function buildQrRedirectUrl(target, origin = 'https://uinvert.com') {
    const normalized = typeof target === 'string' ? target.trim() : '';
    if (!isSafeRedirectTarget(normalized)) {
        return null;
    }
    const base = (origin || 'https://uinvert.com').replace(/\/$/, '');
    return `${base}/qr?to=${encodeURIComponent(normalized)}`;
}
